export const steps = [
  {
    selector: ".first-step",
    // content: "Nuevas actualizaciones",
    position: "right",
  },
  {
    selector: ".second-step",
    // content: "This is the second Step",
  },
  {
    selector: ".third-step",
    // content: "This is the third Step",
  },
  {
    selector: ".fourth-step",
    // content: "This is the fourth Step",
  },
  {
    selector: ".fifth-step",
    // content: "This is the fifth Step",
  },
  {
    selector: ".sixth-step",
    // content: "This is the sixth Step",
  },
  // ...
];
